var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fff","padding":"16px"}},[_c('xz-table',{attrs:{"columns":_vm.columns,"data":_vm.tableData,"scroll":{ x: '100%', y: 540 },"rowKey":'id'},scopedSlots:_vm._u([{key:"url",fn:function(text){return _c('span',{},[_c('a',{attrs:{"href":text,"target":"_blank"}},[_vm._v(_vm._s(text))])])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }